import * as Highcharts from 'highcharts';
import { Directive, ElementRef, Inject, Injectable, InjectionToken, Input, NgModule } from '@angular/core';

/**
 * @license
 * Copyright Felix Itzenplitz. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at
 * https://github.com/cebor/angular-highcharts/blob/master/LICENSE
 */
var Chart = (function () {
    /**
     * @param {?} options
     */
    function Chart(options) {
        this.options = options;
        // init series array if not set
        if (!this.options.series) {
            this.options.series = [];
        }
    }
    /**
     * @param {?} point
     * @param {?=} serieIndex
     * @param {?=} redraw
     * @param {?=} shift
     * @return {?}
     */
    Chart.prototype.addPoint = function (point, serieIndex, redraw, shift) {
        if (serieIndex === void 0) { serieIndex = 0; }
        if (redraw === void 0) { redraw = true; }
        if (shift === void 0) { shift = false; }
        ((this.options.series[serieIndex].data)).push(point);
        if (this.ref) {
            this.ref.series[serieIndex].addPoint(point, redraw, shift);
        }
    };
    /**
     * @param {?} pointIndex
     * @param {?=} serieIndex
     * @return {?}
     */
    Chart.prototype.removePoint = function (pointIndex, serieIndex) {
        if (serieIndex === void 0) { serieIndex = 0; }
        // TODO add try catch (empty)
        ((this.options.series[serieIndex].data)).splice(pointIndex, 1);
        if (this.ref) {
            this.ref.series[serieIndex].removePoint(pointIndex, true);
        }
    };
    /**
     * @param {?} serie
     * @return {?}
     */
    Chart.prototype.addSerie = function (serie) {
        // init data array if not set
        if (!serie.data) {
            serie.data = [];
        }
        this.options.series.push(serie);
        if (this.ref) {
            this.ref.addSeries(serie);
        }
    };
    /**
     * @param {?} serieIndex
     * @return {?}
     */
    Chart.prototype.removeSerie = function (serieIndex) {
        // TODO add try catch (empty)
        this.options.series.splice(serieIndex, 1);
        if (this.ref) {
            this.ref.series[serieIndex].remove(true);
        }
    };
    return Chart;
}());

/**
 * @license
 * Copyright Felix Itzenplitz. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at
 * https://github.com/cebor/angular-highcharts/blob/master/LICENSE
 */
var MapChart = (function () {
    /**
     * @param {?} options
     */
    function MapChart(options) {
        this.options = options;
    }
    return MapChart;
}());

/**
 * @license
 * Copyright Felix Itzenplitz. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at
 * https://github.com/cebor/angular-highcharts/blob/master/LICENSE
 */
var StockChart = (function () {
    /**
     * @param {?} options
     */
    function StockChart(options) {
        this.options = options;
    }
    return StockChart;
}());

/**
 * @license
 * Copyright Felix Itzenplitz. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at
 * https://github.com/cebor/angular-highcharts/blob/master/LICENSE
 */
var ChartDirective = (function () {
    /**
     * @param {?} el
     */
    function ChartDirective(el) {
        this.el = el;
    }
    /**
     * @return {?}
     */
    ChartDirective.prototype.ngAfterViewInit = function () {
        this.init();
    };
    /**
     * @return {?}
     */
    ChartDirective.prototype.ngOnDestroy = function () {
        this.destroy();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    ChartDirective.prototype.ngOnChanges = function (changes) {
        if (!changes['chart'].isFirstChange()) {
            this.destroy();
            this.init();
        }
    };
    /**
     * @return {?}
     */
    ChartDirective.prototype.init = function () {
        if (this.chart instanceof Chart) {
            return this.chart.ref = Highcharts.chart(this.el.nativeElement, this.chart.options);
        }
        if (this.chart instanceof StockChart) {
            return this.chart.ref = ((Highcharts)).stockChart(this.el.nativeElement, this.chart.options);
        }
        if (this.chart instanceof MapChart) {
            return this.chart.ref = ((Highcharts)).mapChart(this.el.nativeElement, this.chart.options);
        }
    };
    /**
     * @return {?}
     */
    ChartDirective.prototype.destroy = function () {
        if (this.chart && this.chart.ref) {
            this.chart.ref.destroy();
            delete this.chart.ref;
        }
    };
    ChartDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[chart]'
                },] },
    ];
    /**
     * @nocollapse
     */
    ChartDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    ChartDirective.propDecorators = {
        'chart': [{ type: Input },],
    };
    return ChartDirective;
}());

/**
 * @license
 * Copyright Felix Itzenplitz. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at
 * https://github.com/cebor/angular-highcharts/blob/master/LICENSE
 */
var HIGHCHARTS_MODULES = new InjectionToken('HighchartsModules');
var ChartService = (function () {
    /**
     * @param {?} chartModules
     */
    function ChartService(chartModules) {
        this.chartModules = chartModules;
    }
    /**
     * @return {?}
     */
    ChartService.prototype.initModules = function () {
        this.chartModules.forEach(function (chartModule) {
            chartModule(Highcharts);
        });
    };
    ChartService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    ChartService.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: Inject, args: [HIGHCHARTS_MODULES,] },] },
    ]; };
    return ChartService;
}());

/**
 * @license
 * Copyright Felix Itzenplitz. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at
 * https://github.com/cebor/angular-highcharts/blob/master/LICENSE
 */
var ChartModule = (function () {
    /**
     * @param {?} cs
     */
    function ChartModule(cs) {
        this.cs = cs;
        this.cs.initModules();
    }
    ChartModule.decorators = [
        { type: NgModule, args: [{
                    exports: [ChartDirective],
                    declarations: [ChartDirective],
                    providers: [
                        { provide: HIGHCHARTS_MODULES, useValue: [] },
                        ChartService
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    ChartModule.ctorParameters = function () { return [
        { type: ChartService, },
    ]; };
    return ChartModule;
}());

/**
 * @license
 * Copyright Felix Itzenplitz. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at
 * https://github.com/cebor/angular-highcharts/blob/master/LICENSE
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of this package.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChartModule, HIGHCHARTS_MODULES, Chart, StockChart, MapChart, ChartDirective as ɵb, ChartService as ɵa };
